import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreLoader } from '@core-lib/classes';
import { ActionType, TiersSortableCols, TiersType } from '@core-lib/enums';
import { IAction, IColumnSettings, IDatagridSettings, IList, ITiers } from '@core-lib/models';
import { DataTableConfigService } from '@core-lib/services/data-table-config.service';
import { DataTableComponentV2 } from '../data-table-v2/data-table-v2.component';

@Component({
    selector: 'tiers-list',
    templateUrl: './tiers-list.component.html',
    styles: [],
    standalone: false
})
export class TiersListComponent extends DataTableComponentV2<ITiers, TiersSortableCols> {
	@Input() loader: StoreLoader;
	@Output() action: EventEmitter<IAction> = new EventEmitter();
	@Input() type: TiersType;
	tiersType = TiersType;
	@Input() data: IList<ITiers> = { items: [] }; // Data
	currentConfig: IDatagridSettings<any> = {
		name: 'TiersSortableCols',
		options: {
			hasPaging: true,
			hasSort: false
		},
		pageNumber: 1,
		pageSize: 20
	};

	columnSettingsPP: Array<IColumnSettings> = [
		{ name: 'nom', isSorted: false, class: 'col-libelle-court', withTooltip: true },
		{ name: 'prenom', isSorted: false, class: 'col-libelle-court', withTooltip: true },
		{ name: 'dateNaissance', isSorted: false, class: 'col-libelle-court', isSpecialColumn: true },
		{ name: 'nationalite', isSorted: false, class: 'col-libelle-court', isSpecialColumn: true }
	];

	columnSettingsPM: Array<IColumnSettings> = [
		{ name: 'libelle', isSorted: false, class: 'col-libelle-court', withTooltip: true },
		{ name: 'formeJuridique', isSorted: false, class: 'col-libelle-court' },
		{ name: 'registre', isSorted: false, class: 'col-libelle-court' },
		{ name: 'denominationCommerciale', isSorted: false, class: 'col-libelle-court', withTooltip: true },
		{ name: 'pays', isSorted: false, class: 'col-libelle-long pays ', isSpecialColumn: true }
	];

	constructor(private configService: DataTableConfigService) {
		super(configService);
	}

	onClose(): void {
		this.action.emit({ type: ActionType.Close });
	}

	onSelectItem(item) {
		this.action.emit({ type: ActionType.Select, value: item });
	}

	onIgnore(): void {
		this.action.emit({ type: ActionType.Ignore });
	}
}
